import { resetUser } from "../features/userSlice";

export const handleExpiredToken = (store) => (next) => (action) => {
  if (
    action?.payload?.status === 401 || 
    action?.payload?.data?.error?.name === "TokenExpiredError"
  ) {
    console.warn("Token expired. Redirecting to login...");

    store.dispatch(resetUser());
    window.location.href = "/login";

    return;
  }

  return next(action);
};